"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const makeGroupBySingleFieldPointerMethod_1 = require("../makeGroupBySingleFieldPointerMethod");
exports.concentrationLimitPointerMethods = [
    (0, makeGroupBySingleFieldPointerMethod_1.makeGroupBySingleFieldPointerMethod)({
        field: 'application_state',
        method: 'enovaInternationalTruistBank1.singleState',
        type: 'string',
        exclusion: {
            largestNumberOfGroups: 4,
        },
    }),
    (0, makeGroupBySingleFieldPointerMethod_1.makeGroupBySingleFieldPointerMethod)({
        field: 'naics_new_code_c',
        method: 'enovaInternationalTruistBank1.singleIndustry',
        type: 'number',
        exclusion: {
            largestNumberOfGroups: 1,
        },
    }),
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map